<script setup>
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import {usePage, router} from '@inertiajs/vue3'
import {computed} from 'vue'
import {useCatalogStore} from "@js/store/CatalogStore.js";

const items = [
    {title: 'Каталог плитки', category: 'plitka'},
    {title: 'Каталог керамогранита', category: 'keramogranit'},
    {title: 'Каталог мозаики', category: 'mozaika'},
    {title: 'Каталог ступеней', category: 'stupeni'},
    {title: 'Каталог искусственного камня', category: 'iskustvenniy_kamen'},
    {title: 'Каталог клинкерной плитки', category: 'klinkernaya_plitka'},
]

const page = usePage()
const catalogStore = useCatalogStore()

// Определяем текущую категорию из URL (например: /catalog/plitka → 'plitka')
const currentCategory = computed(() => {
    const path = new URL(page.props.ziggy.location).pathname
    const parts = path.split('/')
    return parts.includes('catalog') ? parts[parts.indexOf('catalog') + 1] : null
})

function goToCategory(category) {
    if (category !== currentCategory.value) {
        router.visit(route('catalog', {category_title: category, catalog_type: catalogStore.catalog_type}))
    }
}
</script>

<template>
    <div class="w-full overflow-hidden">
        <Swiper :slides-per-view="'auto'" :space-between="16" class="!overflow-visible cursor-grab">
            <template v-for="(item, index) in items">
                <SwiperSlide v-if="item.category !== currentCategory" :key="index" class="!w-auto">
                    <button @click="goToCategory(item.category)"
                            class="inline-flex items-center px-5 py-2.5 border border-gray-300 md:hover:border-baseColor max-md:active:border-baseColor rounded-lg whitespace-nowrap text-sm font-medium transition">
                        {{ item.title }}
                    </button>
                </SwiperSlide>
            </template>
        </Swiper>
    </div>
</template>
